import { WorkflowClient } from './WorkflowClient'
import { workflowEngineClient } from '../WorkflowEngineClient'
import settings from '../../../../../settings'

export const workflowClient = new WorkflowClient(settings.workflowsApiUrl, workflowEngineClient)
